import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1100 800", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h1100v800H0z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M0 75h1100v125H0zm0 525h1100v125H0z", fill: "#0038b8" }), /* @__PURE__ */ React.createElement("path", { d: "M423.816 472.853h252.368L550 254.295zM550 545.705l126.184-218.558H423.816z", fill: "none", stroke: "#0038b8", strokeWidth: 27.5 }));
const ForwardRef = forwardRef(SvgIl);
const Memo = memo(ForwardRef);
export default Memo;
